export { default } from './AutoCompleteWithLabel';
export * from './AutoCompleteWithLabel.types';
